import tw from 'tailwind-styled-components'
import {StickerColor} from 'yougile-model'
import {
  colorTextClass,
  IconStickerColor
} from '@components/common/base/design-system'
import {getSize} from '@components/common/base/icon'
import {IconProps} from '@components/common/base/icon/types'
import {cn} from '@containers/html-utils'

export const TwSticker = tw.div<{
  $isDraggable: boolean
  $showDraggableStyle: boolean
  $isDragging: boolean
  $isActive: boolean
  $hasLeftIcon: boolean
  $hasRightIcon: boolean
  $color: StickerColor
  $required?: boolean
  $hasError?: boolean
  $disabled?: boolean
  $isMac?: boolean
}>`
  relative
  w-fit
  flex
  items-center
  gap-4

  box-border
  outline
  -outline-offset-1
  rounded-[8px]

  ${p => (p.$disabled ? 'cursor-default' : 'cursor-pointer hover:outline-1')}

  ${p => (p.$isMac ? 'tracking-sticker' : '')}

  ${p => {
    return p.$hasLeftIcon ? 'py-2' : 'py-4'
  }}

  ${p => {
    if (p.$color === 'sticker-panel') {
      if (p.$hasRightIcon) {
        return 'pr-4'
      }
      if (p.$hasLeftIcon) {
        return 'pr-6'
      }
      return 'pr-8'
    }

    if (p.$hasRightIcon) {
      return 'pr-4'
    }

    return `${p.$hasLeftIcon ? 'pr-6' : 'pr-8'}`
  }}

  ${p => {
    if (!p.$hasRightIcon && !p.$hasLeftIcon) {
      return 'pl-8'
    }

    if (p.$hasRightIcon && p.$hasLeftIcon) {
      return ['sticker-panel', 'sticker-white'].includes(p.$color)
        ? 'pl-4'
        : 'pl-2'
    }

    if (p.$color === 'sticker-panel') {
      return p.$hasLeftIcon ? 'pl-4' : 'pl-6'
    }

    if (p.$color === 'sticker-white') {
      return 'pl-4'
    }

    return p.$hasLeftIcon ? 'pl-2' : 'pl-6'
  }}

  ${p => {
    if (p.$isDragging || !p.$showDraggableStyle) {
      return ''
    }
    return p.$isDraggable ? '!cursor-grab hover:shadow-lg' : ''
  }}

  ${p => {
    if (p.$isActive) {
      return `outline-1 ${
        p.$color === 'sticker-transparent'
          ? `outline-${p.$color}`
          : 'outline-action-default'
      }`
    }
    if (p.$hasError) {
      return 'outline-1 outline-status-error'
    }
    return `outline-${p.$color}`
  }}

  ${p => {
    return `bg-${p.$color} text-${p.$color}`
  }}

  ${p => {
    return p.$color === 'sticker-white'
      ? `outline-1 ${p.$disabled ? '' : 'hover:outline-line-hover'}`
      : 'outline-0'
  }}
`

export const TwStickerIconBackground = tw.div<{$color: IconStickerColor}>`
  p-2
  ${({$color}) =>
    ['icon-sticker-white', 'icon-sticker-panel'].includes($color) ? 'px-0' : ''}

  box-border
  rounded-[6px]

  ${({$color}) => {
    return $color ? `bg-${$color}` : ''
  }}
`

export const TwStickerTitle = tw.div`
  whitespace-nowrap
  text-12
  leading-[16px]
  max-w-[148px]
  relative
  truncate
`

export const TwStickerRequired = tw.div`
  absolute
  right-2
  -top-2
  text-notification-primary
  text-12
`

export const TwCustomIconWrapper = tw.div<{
  $color: IconStickerColor | 'action-default'
  $size: IconProps['size']
}>`
  flex
  items-center
  justify-center
  select-none
  ${p => cn(colorTextClass(p.$color), getSize(p.$size))}
`
